import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Card from "../../../../../../components/Card/Card";
import {
  CardContent,
  CardHeader,
  Divider, FormControlLabel,
  Grid, Switch,
  TextField
} from "@mui/material";
import * as Yup from "yup";
import {ErrorMessage, Formik} from "formik";
import {useState} from "react";
import {isEmpty} from "underscore";
import FilterDropdown from "../../../../../Document/components/panelSegments/FilterDropdown";
import {GridItem} from "../../../../../../components/Grid";
import NameBasedMenuItem, {
  NameBasedMenuItemWithIdReturn
} from "../../../../../Document/components/panelSegments/components/NameBasedMenuItem";

const ESignUpload_XXXX = props => {
  const {
    classes,
    showModal,
    setShowModal,
    includeAllSections = true,
    includeAllClassifications = true,
    includeAllCategories = true,
    includeAllCompanies = true,
    searchSectionsByMethod = NameBasedMenuItem,
    searchClassificationsByMethod = NameBasedMenuItem,
    searchCompaniesByMethod = NameBasedMenuItem,
    searchCategoriesByMethod = NameBasedMenuItem,
    initialCompanies,
    initialCategories,
    initialSections,
    initialClassifications,
    sectionSelect,
    categorySelect,
    companySelect,
    classificationSelect,
    onHandleClassificationSelect,
    onHandleCategorySelect,
    onHandleSectionSelect,
    onHandleCompanySelect,
    handleCloseModal,
    onUploadContinue,
    pageTitle,
    selectedDocuments,
    renderButton,
    buttonText,
    buttonIcon,
    onButtonClick,
    customButtons = [],
    view
  } = props;

  const [fullWidth] = React.useState(true);
  const [maxWidth] = React.useState('sm');
  const [hasErrors, setHasErrors] = useState(false);

  let required = true;

  let validationSchema = "";
  if (view === "notes"){
    validationSchema = Yup.object().shape({
      notes: Yup.string()
        .when('$hasNotes', (hasNotes, minSchema) => hasNotes
          ? minSchema
          : minSchema).min(10, 'Notes are OPTIONAL.  If FILLED, notes must contain at least 10 characters.'),
        });
  } else {
    validationSchema = Yup.object().shape({
      notes: Yup.string()
        .trim()
        .min(10, 'Notes must contain at least 10 characters')
        .when('$required', (required, requireSchema) => required
          ? requireSchema
          : requireSchema).required('Notes are required and must be at least 10 characters.'),
    });
  }

  const initialTouched = {
    "notes": true
  };

  const allButtonElements = [];
  if (renderButton) allButtonElements.push(
    <Button
      color="primary"
      className={classes.button}
      component="span"
      variant="contained"
      onClick={onButtonClick}
    >
      {buttonIcon ? React.createElement(buttonIcon) : undefined} {buttonText}
    </Button>);
  if (customButtons) customButtons.forEach(button => allButtonElements.push(button));

  const buttonGridItems = [];
  allButtonElements.forEach((button, index) => buttonGridItems.push(<GridItem
    key={index}
    xs={12}
    md={2}
  >
    {button}
  </GridItem>));

  return (
    <React.Fragment>
      <Formik
        enableReinitialize
        initialTouched={initialTouched}
        initialValues={selectedDocuments}
        innerRef={self=>setHasErrors(self && !isEmpty(self.touched) && !isEmpty(self.errors))}
        onSubmit={(values) => {
        }}
        validateOnMount
        validationSchema={validationSchema}
      >
        {(formikProps) => {
          const {
            values,
            handleBlur,
            handleSubmit
          } = formikProps;

          return (
            <Dialog
              fullWidth={fullWidth}
              maxWidth={maxWidth}
              open={showModal}
              onClose={handleCloseModal}
            >
              <DialogTitle>{pageTitle}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                     All eSign documents uploaded will be stored with these values
                </DialogContentText>
                <form>
                  <div className={classes.root}>
                    <Card className={classes.content}>
                      <Grid
                        item
                        md={12}
                      >
                        <CardHeader
                          // title="Enter Notes: "
                        />
                        <Divider/>
                        <CardContent>
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                            >
                              <Grid container>
                                <FilterDropdown
                                  classes={classes}
                                  optionNameDisplay={"Company"}
                                  optionNameDisplayPlural={"Companies"}
                                  optionNameInternal={"companySelect"}
                                  optionId={"company-select"}
                                  includeAllOptionsAsOption={includeAllCompanies}
                                  initialOptions={initialCompanies}
                                  onHandleSelect={onHandleCompanySelect}
                                  optionSelect={companySelect}
                                  menuItemListMethod={searchCompaniesByMethod}
                                />
                                <FilterDropdown
                                  classes={classes}
                                  optionNameDisplay={"Section"}
                                  optionNameDisplayPlural={"Sections"}
                                  optionNameInternal={"sectionSelect"}
                                  optionId={"section-select"}
                                  includeAllOptionsAsOption={includeAllSections}
                                  initialOptions={initialSections}
                                  onHandleSelect={onHandleSectionSelect}
                                  optionSelect={sectionSelect}
                                  menuItemListMethod={searchSectionsByMethod}
                                />
                                <FilterDropdown
                                  classes={classes}
                                  optionNameDisplay={"Media Type"}
                                  optionNameDisplayPlural={"Media Types"}
                                  optionNameInternal={"classificationSelect"}
                                  optionId={"classification-select"}
                                  includeAllOptionsAsOption={includeAllClassifications}
                                  initialOptions={initialClassifications}
                                  onHandleSelect={onHandleClassificationSelect}
                                  optionSelect={classificationSelect}
                                  menuItemListMethod={searchClassificationsByMethod}
                                />
                                <FilterDropdown
                                  classes={classes}
                                  optionNameDisplay={"Category"}
                                  optionNameDisplayPlural={"Categories"}
                                  optionNameInternal={"categorySelect"}
                                  optionId={"category-select"}
                                  includeAllOptionsAsOption={includeAllCategories}
                                  initialOptions={initialCategories}
                                  onHandleSelect={onHandleCategorySelect}
                                  optionSelect={categorySelect}
                                  menuItemListMethod={searchCategoriesByMethod}
                                />
                              </Grid>
                            </Grid>
                            <Grid container>
                              {buttonGridItems}
                            </Grid>
                          </Grid>
                        </CardContent>
                      </Grid>
                    </Card>
                  </div>
                </form>
              </DialogContent>
              <DialogActions>
                <Button aria-label="Create" className={classes.createButton}
                        color="primary"
                        type="submit"
                        variant="contained"
                        required={required}
                        disabled={(hasErrors)}
                        onClick={onUploadContinue}
                >
                  Upload
                </Button>
              </DialogActions>

            </Dialog>
          )}
        }
      </Formik>
    </React.Fragment>
  );
}

export default ESignUpload_XXXX;
